import { Component, Input } from '@angular/core';

@Component({
    'selector': 'payment-formbox-header',
    'templateUrl': './payment-formbox-header.component.html'
})
export class FormboxHeaderComponent {
    @Input() title: string;
    @Input() icon: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/formbox-header/payment-formbox-header.component.ts